var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.96 251C197.826 251 198.528 250.298 198.528 249.431V54.0369C198.528 53.171 197.826 52.4682 196.96 52.4682H1.56875C0.702875 52.4682 0 53.171 0 54.0369V249.431C0 250.298 0.702875 251 1.56875 251H196.96ZM195.391 247.862H3.1375V55.6056H195.391V247.862Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.431 198.533C250.297 198.533 251 197.83 251 196.964V1.56875C251 0.702875 250.297 0 249.431 0H54.0404C53.1743 0 52.4716 0.702875 52.4716 1.56875V196.964C52.4716 197.83 53.1743 198.533 54.0404 198.533H249.431ZM247.863 195.395H55.6091V3.1375H247.863V195.395Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 250.543L250.542 198.075L248.32 195.855L195.852 248.323L198.067 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67974 250.543L55.1515 198.075L52.9326 195.855L0.461029 248.323L2.67974 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68311 55.1389L55.1546 2.30747L52.9292 0.0987106L0.457656 52.9259L2.68311 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.074 55.1389L250.546 2.30747L248.32 0.0987106L195.849 52.9258L198.074 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 238.33L55.148 185.861L52.9292 183.642L0.461029 236.111L2.67647 238.33Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 226.116L55.148 173.648L52.9292 171.429L0.461029 223.897L2.67647 226.116Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 213.903L55.148 161.435L52.9292 159.218L0.461029 211.683L2.67647 213.903Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 201.689L55.148 149.221L52.9292 147.006L0.461029 199.474L2.67647 201.689Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 189.479L55.148 137.011L52.9292 134.792L0.461029 187.26L2.67647 189.479Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 177.266L55.148 124.798L52.9292 122.578L0.461029 175.047L2.67647 177.266Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 165.053L55.148 112.584L52.9292 110.366L0.461029 162.834L2.67647 165.053Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 152.839L55.148 100.371L52.9292 98.152L0.461029 150.62L2.67647 152.839Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 140.626L55.148 88.1579L52.9292 85.9415L0.461029 138.41L2.67647 140.626Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 128.416L55.148 75.9476L52.9292 73.7287L0.461029 126.196L2.67647 128.416Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 116.202L55.148 63.7338L52.9292 61.5151L0.461029 113.983L2.67647 116.202Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 103.989L55.148 51.5212L52.9292 49.3013L0.461029 101.77L2.67647 103.989Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 91.7755L55.148 39.3074L52.9292 37.0887L0.461029 89.5568L2.67647 91.7755Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 79.562L55.148 27.0937L52.9292 24.8784L0.461029 77.3465L2.67647 79.562Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67647 67.3516L55.148 14.8842L52.9292 12.6647L0.461029 65.1328L2.67647 67.3516Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M185.858 250.543L238.329 198.075L236.11 195.855L183.638 248.323L185.858 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M173.644 250.543L226.116 198.075L223.896 195.855L171.429 248.323L173.644 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M161.434 250.543L213.906 198.075L211.687 195.855L159.215 248.323L161.434 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M149.221 250.543L201.692 198.075L199.473 195.855L147.001 248.323L149.221 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M137.011 250.543L189.482 198.075L187.263 195.855L134.791 248.323L137.011 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M124.797 250.543L177.269 198.075L175.05 195.855L122.578 248.323L124.797 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M112.587 250.543L165.058 198.075L162.84 195.855L110.368 248.323L112.587 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M100.374 250.543L152.846 198.075L150.626 195.855L98.1544 248.323L100.374 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1603 250.543L140.635 198.075L138.416 195.855L85.9449 248.323L88.1603 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.95 250.543L128.422 198.075L126.203 195.855L73.7313 248.323L75.95 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7373 250.543L116.209 198.075L113.989 195.855L61.5208 248.323L63.7373 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5269 250.543L103.999 198.075L101.779 195.855L49.3082 248.323L51.5269 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3132 250.543L91.7848 198.075L89.566 195.855L37.0944 248.323L39.3132 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1037 250.543L79.5745 198.075L77.3556 195.855L24.8842 248.323L27.1037 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8901 250.543L67.3617 198.075L65.1421 195.855L12.6712 248.323L14.8901 250.543Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 238.33L250.542 185.861L248.32 183.642L195.852 236.111L198.067 238.33Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 226.116L250.542 173.648L248.32 171.429L195.852 223.897L198.067 226.116Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 213.903L250.542 161.435L248.32 159.218L195.852 211.683L198.067 213.903Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 201.689L250.542 149.221L248.32 147.006L195.852 199.474L198.067 201.689Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 189.479L250.542 137.011L248.32 134.792L195.852 187.26L198.067 189.479Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 177.266L250.542 124.798L248.32 122.578L195.852 175.047L198.067 177.266Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 165.053L250.542 112.584L248.32 110.366L195.852 162.834L198.067 165.053Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 152.839L250.542 100.371L248.32 98.152L195.852 150.62L198.067 152.839Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 140.626L250.542 88.1579L248.32 85.9415L195.852 138.41L198.067 140.626Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 128.416L250.542 75.9476L248.32 73.7287L195.852 126.196L198.067 128.416Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 116.202L250.542 63.7338L248.32 61.5151L195.852 113.983L198.067 116.202Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 103.989L250.542 51.5212L248.32 49.3013L195.852 101.77L198.067 103.989Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 91.7755L250.542 39.3074L248.32 37.0887L195.852 89.5568L198.067 91.7755Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 79.562L250.542 27.0937L248.32 24.8784L195.852 77.3465L198.067 79.562Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 67.3516L250.542 14.8842L248.32 12.6647L195.852 65.1328L198.067 67.3516Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M198.067 67.3516L250.542 14.8842L248.32 12.6647L195.852 65.1328L198.067 67.3516Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8935 55.1389L67.3651 2.30747L65.1386 0.0987106L12.668 52.9259L14.8935 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1063 55.1389L79.5779 2.30747L77.3522 0.0987106L24.8807 52.9259L27.1063 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3167 55.1389L91.7916 2.30747L89.5626 0.0987106L37.0911 52.9258L39.3167 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5304 55.1389L104.002 2.30747L101.776 0.0987106L49.3048 52.9258L51.5304 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7431 55.1389L116.215 2.30747L113.989 0.0987106L61.5143 52.9258L63.7431 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9533 55.1389L128.425 2.30747L126.199 0.0987106L73.7278 52.9258L75.9533 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M88.167 55.1389L140.639 2.30747L138.413 0.0987106L85.9415 52.9258L88.167 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M100.377 55.1389L152.848 2.30747L150.622 0.0987106L98.1509 52.9258L100.377 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M112.59 55.1389L165.062 2.30747L162.836 0.0987106L110.365 52.9258L112.59 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M124.801 55.1389L177.272 2.30747L175.047 0.0987106L122.575 52.9258L124.801 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M137.014 55.1389L189.486 2.30747L187.259 0.0987106L134.789 52.9258L137.014 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M149.224 55.1389L201.695 2.30747L199.47 0.0987106L146.998 52.9258L149.224 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M161.437 55.1389L213.909 2.30747L211.683 0.0987106L159.212 52.9258L161.437 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M173.648 55.1389L226.122 2.30747L223.896 0.0987106L171.422 52.9258L173.648 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M185.861 55.1389L238.332 2.30747L236.106 0.0987106L183.635 52.9258L185.861 55.1389Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog5);
export default __webpack_public_path__ + "static/media/blog5.99d8e9531015965cbb284f7394adbbf2.svg";
export { ForwardRef as ReactComponent };